import ModalConfirmComponent from 'components/modal-confirm'
import { UpsertStudentProps } from 'types/StudentTypes'

interface RegisterUserComponentProps {
  isShow: boolean
  name: string
  phone: string
  onActionCancel: () => void
  onActionSubmit: (user: UpsertStudentProps) => void
}

const RegisterUserComponent = ({ isShow, name, phone, onActionCancel, onActionSubmit }: RegisterUserComponentProps) => {
  return (
    <ModalConfirmComponent
      isShow={isShow}
      title={`Send SignUp Link?`}
      body={`Sends an SMS with a signup link to this user`}
      actionIcon={'yellowSendIcon'}
      actionText={'Send'}
      onActionCancel={onActionCancel}
      onActionSubmit={async () => {
        onActionSubmit({
          userPhoneNumber: phone,
          userName: name,
        })
      }}
    />
  )
}

export default RegisterUserComponent
